<script setup lang="ts">
import { PhArrowRight as ArrowRight, PhClock as Clock, PhGift as Gift, PhIdentificationCard as IdentificationCard, PhLockKey as LockKey, PhPlay as Play, PhShieldCheck as ShieldCheck, PhSparkle as Sparkle } from "@phosphor-icons/vue";
import BrandBar from "./BrandBar.vue";
import CharacterStage from "./CharacterStage.vue";
import { useSessionStore } from "../stores/session";

const store = useSessionStore();
</script>

<template>
  <section class="screen screen--home">
    <div class="home-topline">
      <BrandBar />
      <button v-if="store.result" class="result-entry-button" type="button" @click="store.revealResult">
        <IdentificationCard :size="17" weight="fill" /> 查看测试结果
      </button>
    </div>

    <header class="home-heading">
      <p class="eyebrow">鉴定你是哪种牛马，附赠轻养回血指南</p>
      <h1>
        <span class="home-title-main">NBTI 牛马体质</span>
        <span class="home-title-sub">测测你的“班味”浓度有多深？</span>
      </h1>
    </header>

    <CharacterStage
      variant="hero"
      src="/assets/hero-scanner.webp"
      alt="职场人在低多边形身份扫描舱中接受牛马体质鉴定"
      code="NBTI / V2"
      label="NBTI 牛马体质身份扫描舱"
    />

    <section class="countdown-card" aria-label="2026 牛马体质测试活动">
      <div class="countdown-badge"><Sparkle :size="15" weight="fill" /> 2026 下班倒计时</div>
      <div class="countdown-copy">
        <strong>什么？2026 年倒计时了，<br />你还在做“汉血牛马”？</strong>
        <span>点击测试，看看你到底有多班味</span>
      </div>
      <div class="gift-chip"><Gift :size="20" weight="fill" /><span><small>测试配备</small>工位回血方案</span></div>
    </section>

    <div class="fact-line" aria-label="测试说明">
      <span><IdentificationCard :size="18" weight="bold" /> 5 道题</span>
      <span><Clock :size="18" weight="bold" /> 约 20–30 秒</span>
      <span><LockKey :size="18" weight="bold" /> 无需登录</span>
    </div>

    <button class="button button--primary button--large" @click="store.start">
      <Play :size="23" weight="fill" /> 立即测试 <ArrowRight :size="21" weight="bold" />
    </button>

    <p class="home-assurance"><ShieldCheck :size="17" weight="fill" /> 完整结果直接可见 · 可领取解决方案＋申请体验资格</p>
    <p class="compliance">仅供娱乐，不构成医学、心理学或职业诊断</p>
  </section>
</template>
